import { gql } from '@apollo/client';

import { mediaListItemFragment } from '../fragments';

export default gql`
  query GetMediaItemByCourse($courseId: String!) {
    mediaItems(courseId: $courseId)
      @rest(type: "MediaItem", path: "courses/{args.courseId}/videos") {
      ...MediaListItem
    }
  }
  ${mediaListItemFragment}
`;
